export default () => {
  const links = document.querySelectorAll('.link');

  links.forEach((link) => {
    let cleanTimeout;

    link.addEventListener('mouseenter', () => {
      clearTimeout(cleanTimeout);
      link.classList.add('hover-on');
      link.classList.remove('hover-out');
    });

    link.addEventListener('mouseleave', () => {
      link.classList.remove('hover-on');
      link.classList.add('hover-out');

      cleanTimeout = setTimeout(() => {
        link.classList.remove('hover-out');
      }, 450);
    })
  });
};
